import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'grid',
    `
			position: relative;
			display: flex;
			flex-wrap: wrap;
		`
  ],
  [
    'item',
    (_, [column, gutter]) => [
      `
				position: relative;
				width: calc((100% - ${gutter * (column - 1)}px) /${column});
				margin-right: ${gutter}px;
				line-height: 0;
				box-sizing: border-box;

				&:nth-of-type(${column}n) {
					margin-right: 0;
				}
			`
    ]
  ]
]);
